const NotFound = () => (
  <div className="p-8 text-3xl">
    <h1>404 - There's nothing here!</h1>
  </div>
);

export default NotFound;
